import { API_BASIC_URL } from '@/constants'
import { GenericAbortSignal } from 'axios'
import type { IPaginationParam, IPaginationResponse, IQueryData } from '../types'
import { createAxiosInstance } from '../utils'

const axios = createAxiosInstance({
  baseURL: API_BASIC_URL,
  withAuth: true,
  headers: {
    // 'x-api-version': 5.1,
  },
})

export const fetchQueryData = (params?: IPaginationParam, signal?: GenericAbortSignal) => {
  return axios
    .get<{ data: IPaginationResponse<IQueryData> }>(`/master-report/query-data`, { params, signal })
    .then((response) => response.data.data)
}

export const createQueryData = (payload: Record<string, any>) => {
  return axios.post<{ data: IQueryData }>(`/master-report/query-data`, payload).then((response) => response.data.data)
}

export const updateQueryData = (oid: string, payload: Record<string, any>) => {
  return axios.put<{ data: IQueryData }>(`/master-report/query-data/${oid}`, payload).then((response) => response.data.data)
}

export const deleteQueryData = (oid: string) => {
  return axios.delete(`/master-report/query-data/${oid}`)
}
